import sanitizeAnalyticsEventProperties from "./sanitizeAnalyticsEventProperties";

export const SANITIZE_ANALYTICS_URL_PLUGIN_NAME = "squaber-sanitize-analytics-url";

export default function createSanitizeAnalyticsUrlPlugin() {
  return {
    name: SANITIZE_ANALYTICS_URL_PLUGIN_NAME,
    type: "enrichment",
    execute: async event => {
      if (!event?.event_properties) {
        return event;
      }

      const eventProperties = sanitizeAnalyticsEventProperties(
        event.event_properties
      );

      if (eventProperties === event.event_properties) {
        return event;
      }

      return {
        ...event,
        event_properties: eventProperties
      };
    }
  };
}
